import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';
import ProtectedBadge from 'components/org-client/ProtectedBadge';

/**
 * Tile de métrica del panel de empresa. Nace aparte de `StatCard` (gamificación) porque
 * aquel solo admite texto o número como valor y aquí el valor puede ser un candado con su
 * explicación de privacidad, que es justo el estado que no se puede degradar a una celda muda.
 */
function OrgStatTile({
  icon = null,
  label,
  value = '--',
  unit = null,
  hint = null,
  isProtected = false
}) {
  return (
    <Box
      sx={{
        height: '100%',
        p: 2.25,
        borderRadius: 3,
        backgroundColor: 'surface.raised',
        border: '1px solid',
        borderColor: 'hairline.main',
        boxShadow: (theme) => theme.palette.shadow?.card,
        transition: 'transform 200ms cubic-bezier(0.32, 0.72, 0, 1), border-color 200ms cubic-bezier(0.32, 0.72, 0, 1)',
        '&:hover': { transform: 'translateY(-2px)', borderColor: 'hairline.strong' }
      }}>
      <Stack direction="row" spacing={1.25} alignItems="center" sx={{ mb: 1.5 }}>
        {icon && (
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 2,
              flex: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'gold.soft',
              color: 'gold.main'
            }}>
            {icon}
          </Box>
        )}
        <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.secondary', minWidth: 0 }} noWrap>
          {label}
        </Typography>
      </Stack>

      {isProtected ? (
        <ProtectedBadge />
      ) : (
        <Stack direction="row" spacing={0.5} alignItems="baseline">
          <Typography sx={{ fontSize: '2rem', fontWeight: 800, lineHeight: 1, fontVariantNumeric: 'tabular-nums' }}>
            {value}
          </Typography>
          {unit && (
            <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 700 }}>
              {unit}
            </Typography>
          )}
        </Stack>
      )}

      {hint && (
        <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.75 }}>
          {hint}
        </Typography>
      )}
    </Box>
  );
}

OrgStatTile.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  unit: PropTypes.string,
  hint: PropTypes.string,
  isProtected: PropTypes.bool
};

export default OrgStatTile;
